//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config/index';
export default {
  name: 'register',
  data: function data() {
    var _this = this;

    return {
      current: 0,
      enterButton: this._vm.$t('loginArea.getvcode'),
      formData: {
        mobile: '',
        code: '',
        password: '',
        password1: '',
        org_code: '',
        email: '',
        interest: true
      },
      butDisabled: false,
      rules: {
        mobile: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
            var emailReg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;

            if (!value) {
              callback(new Error(_this._vm.$t('loginArea.mobileEmailplaceholder')));
            } else if (!myreg.test(value) && !emailReg.test(value)) {
              callback(new Error(_this._vm.$t('loginArea.mobileInputMess')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: this._vm.$t('loginArea.getvcodenotice'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this._vm.$t('loginArea.passwordNotNull'),
          trigger: 'blur'
        }],
        password1: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this._vm.$t('loginArea.inputAgainPass')));
            } else if (value !== _this.formData.password) {
              callback(new Error(_this._vm.$t('loginArea.comparePass')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        org_code: [{
          required: true,
          message: this._vm.$t('loginArea.companyName'),
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: this._vm.$t('loginArea.emailNotNull'),
          trigger: 'blur'
        }, {
          type: 'email',
          message: this._vm.$t('loginArea.emailIncorrect'),
          trigger: 'blur'
        }],
        interest: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this._vm.$t('loginArea.noticeServiceTrems')));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    $store: {},
    _vm: {}
  },
  computed: {
    //法律法规
    getDocUrl: function getDocUrl() {
      var root = '';

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      var lan = localStorage.getItem('local');
      var doc;

      if (lan === 'zh-CN') {
        doc = '/static/yszc.html';
      } else {
        doc = '/static/yszc_en.html';
      }

      return root + doc;
    },
    //服务条款
    getDocServiceUrl: function getDocServiceUrl() {
      var root = '';

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      var lan = localStorage.getItem('local');
      var doc;

      if (lan === 'zh-CN') {
        doc = '/static/fwtk.html';
      } else {
        doc = '/static/fwtk_en.html';
      }

      return root + doc;
    }
  },
  methods: {
    //服务条款
    viewService: function viewService() {
      window.open(this.getDocServiceUrl);
    },

    /**
     * 法律声明及隐私权政策
     */
    viewNotice: function viewNotice() {
      window.open(this.getDocUrl);
    },
    handleSubmit: function handleSubmit(submit) {
      var _this2 = this;

      this.$refs.formData.validate(function (valid) {
        if (valid) {
          submit();
        } else {
          _this2.$Message.error(_this2._vm.$t('loginArea.requireFieldsNotice'));
        }
      });
    },
    getCode: function getCode() {
      var _this3 = this;

      var time = 120,
          vm = this;
      var mobile = this.formData.mobile,
          myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/,
          emailReg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      this.$refs.formData.validateField('mobile', function (valide) {
        if (valide === '') {
          var callback = function callback(res) {
            if (res.result === 0) {
              _this3.$Message.success(res.errorMsg);

              vm.butDisabled = true;
              var setinter = setInterval(function () {
                if (time > 0) {
                  time--;
                  vm.enterButton = time + vm._vm.$t('loginArea.getVodeSecondAfter');
                } else {
                  vm.enterButton = vm._vm.$t('loginArea.getvcode');
                  vm.butDisabled = false;
                  clearInterval(setinter);
                }
              }, 1000);
            } else {
              _this3.$Message.error(res.errorMsg);
            }
          };

          if (myreg.test(mobile)) {
            vm.$store.dispatch('handleGetsms', {
              mobile: mobile,
              type: 1
            }).then(function (res) {
              callback(res);
            });
          } else if (emailReg.test(mobile)) {
            vm.$store.dispatch('handleGetEmall', {
              email: mobile,
              type: 1
            }).then(function (res) {
              callback(res);
            });
          }
        }
      });
    }
  },
  mounted: function mounted() {}
};